module.exports = __webpack_public_path__ + "static/media/catfish-in-water.51ca3319.png";